import type { ComponentProps } from "react"
import { useQuerySelectorLazy } from "@/v2-ui/utils/utils.dom"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogContent as AlertDialogContentBase } from "./base/AlertDialogBase"
import AlertDialogPortal from "./AlertDialogPortal"
import AlertDialogOverlay from "./AlertDialogOverlay"

const DEFAULT_PORTAL_CONTAINER = "#mount"

export type AlertDialogContentProps = ComponentProps<
  typeof AlertDialogContentBase
> & {
  portalContainer?: string
  hasOverlay?: boolean
}

function AlertDialogContent(props: AlertDialogContentProps) {
  const {
    portalContainer = DEFAULT_PORTAL_CONTAINER,
    hasOverlay = true,
    className,
    ...alertDialogContentBaseProps
  } = props

  const portalElem = useQuerySelectorLazy(portalContainer)

  return (
    <AlertDialogPortal container={portalElem}>
      {hasOverlay ? <AlertDialogOverlay /> : null}
      <AlertDialogContentBase
        className={cn("ui-alert-dialog-content", className)}
        {...alertDialogContentBaseProps}
      />
    </AlertDialogPortal>
  )
}

export default AlertDialogContent
